import { on as s } from "../utils/dom/event.js";
function c(o, t) {
  return o > t ? "horizontal" : t > o ? "vertical" : "";
}
var u = {
  data: function data() {
    return {
      direction: ""
    };
  },
  methods: {
    touchStart: function touchStart(t) {
      this.resetTouchStatus(), this.startX = t.touches[0].clientX, this.startY = t.touches[0].clientY;
    },
    touchMove: function touchMove(t) {
      var i = t.touches[0];
      this.deltaX = i.clientX < 0 ? 0 : i.clientX - this.startX, this.deltaY = i.clientY - this.startY, this.offsetX = Math.abs(this.deltaX), this.offsetY = Math.abs(this.deltaY);
      var h = 10;
      (!this.direction || this.offsetX < h && this.offsetY < h) && (this.direction = c(this.offsetX, this.offsetY));
    },
    resetTouchStatus: function resetTouchStatus() {
      this.direction = "", this.deltaX = 0, this.deltaY = 0, this.offsetX = 0, this.offsetY = 0;
    },
    // avoid Vue 2.6 event bubble issues by manually binding events
    // https://github.com/vant-ui/vant/issues/3015
    bindTouchEvent: function bindTouchEvent(t) {
      var i = this.onTouchStart,
        h = this.onTouchMove,
        e = this.onTouchEnd;
      s(t, "touchstart", i), s(t, "touchmove", h), e && (s(t, "touchend", e), s(t, "touchcancel", e));
    }
  }
};
export { u as TouchMixin };
